const plans = [
  {
    handle: 'flexible',
    title: 'Starter',
    available: false,
    monthlyPrice: 0,
    yearlyPrice: 0,
    yearlyPriceFull: 0,
    transactionFeePercentage: 4,
    seats: 1,
    description: 'Legacy plan',
    benefits: ['4% transaction fee'],
  },
  {
    handle: 'premium',
    title: 'Premium',
    available: false,
    monthlyPrice: 2900,
    yearlyPrice: 2900,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0.5,
    seats: 1,
    description: 'Legacy plan',
    benefits: ['0.5% transaction fee'],
  },
  {
    handle: 'launch',
    version: 1,
    title: 'Launch',
    available: false,
    monthlyPrice: 2900,
    yearlyPrice: 2400,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0,
    seats: 2,
    benefits: ['Up to $3K sales per month'],
  },
  {
    handle: 'launch',
    version: 2,
    title: 'Launch',
    available: false,
    monthlyPrice: 2900,
    yearlyPrice: 1900,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0,
    seats: 2,
    benefits: ['Up to $3K sales per month'],
  },
  {
    handle: 'launch',
    version: 3,
    title: 'Launch',
    available: true,
    monthlyPrice: 2900,
    yearlyPrice: 2400,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0,
    benefits: ['Up to $3K sales per month'],
  },
  {
    handle: 'grow',
    version: 1,
    title: 'Grow',
    available: false,
    monthlyPrice: 5900,
    yearlyPrice: 4700,
    yearlyPriceFull: 59000,
    transactionFeePercentage: 0,
    seats: 3,
    benefits: ['Up to $10K sales per month'],
  },
  {
    handle: 'grow',
    version: 2,
    title: 'Grow',
    available: false,
    monthlyPrice: 7900,
    yearlyPrice: 4900,
    yearlyPriceFull: 79000,
    transactionFeePercentage: 0,
    seats: 3,
    benefits: ['Up to $10K sales per month'],
  },
  {
    handle: 'grow',
    version: 3,
    title: 'Grow',
    available: true,
    monthlyPrice: 9900,
    yearlyPrice: 8300,
    yearlyPriceFull: 99000,
    transactionFeePercentage: 0,
    benefits: ['Up to $10K sales per month'],
  },
  {
    handle: 'scale',
    version: 1,
    title: 'Scale',
    available: false,
    monthlyPrice: 19900,
    yearlyPrice: 15000,
    yearlyPriceFull: 199000,
    transactionFeePercentage: 0,
    seats: 10,
    benefits: ['Unlimited sales per month'],
  },
  {
    handle: 'scale',
    version: 2,
    title: 'Scale',
    available: false,
    monthlyPrice: 14900,
    yearlyPrice: 9900,
    yearlyPriceFull: 149000,
    transactionFeePercentage: 0,
    seats: 10,
    benefits: ['Unlimited sales per month'],
  },
  {
    handle: 'scale',
    version: 3,
    title: 'Scale',
    available: true,
    monthlyPrice: 23900,
    yearlyPrice: 19900,
    yearlyPriceFull: 239000,
    transactionFeePercentage: 0,
    benefits: ['Up to $30K sales per month'],
  },
  {
    handle: 'enterprise',
    version: 1,
    title: 'Enterprise',
    available: true,
    transactionFeePercentage: 0,
    benefits: ['Selling more than $100K per month? Contact us for custom pricing.'],
  },
];

function getPlanWithHighestVersion(handle) {
  const plansWithHandle = plans.filter(plan => plan.handle === handle);

  return plansWithHandle.sort((a, b) => b.version - a.version)[0];
}

function getPlanWithVersion(handle, version) {
  return plans.find(plan => plan.handle === handle && plan.version === version);
}

function getPlan(handle, version = null) {
  if (version) {
    const plan = getPlanWithVersion(handle, version);

    if (plan) {
      return plan;
    }
  }

  return getPlanWithHighestVersion(handle);
}

function getBillingPeriod(billingPeriod) {
  switch (billingPeriod) {
    case 'year':
      return 'yearly';
    case 'month':
      return 'monthly';
    default:
      return 'monthly';
  }
}

export { getPlan, getBillingPeriod };

export default plans;
